import { render, staticRenderFns } from "./editDes.vue?vue&type=template&id=1f624c2b&scoped=true"
import script from "./editDes.vue?vue&type=script&lang=js"
export * from "./editDes.vue?vue&type=script&lang=js"
import style0 from "./editDes.vue?vue&type=style&index=0&id=1f624c2b&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_21c2e229d51f918cc63b499183bc63cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f624c2b",
  null
  
)

export default component.exports